// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.K5uLBV2MralLwfsjdhKn ul {
  list-style: none;
  padding: 0;
  margin: 0;
}
.K5uLBV2MralLwfsjdhKn ul li {
  padding-bottom: 10px;
}
.K5uLBV2MralLwfsjdhKn ul a {
  color: #0C3058;
  transition: 0.3s;
  font-size: 16px;
}
.K5uLBV2MralLwfsjdhKn ul a:hover, .K5uLBV2MralLwfsjdhKn ul a.luBhwvTr4AVXuicFVXFp {
  color: #0068F5;
}
.K5uLBV2MralLwfsjdhKn ul a span {
  padding-left: 5px;
  color: #0C3058;
  font-size: 16px;
}`, "",{"version":3,"sources":["webpack://./GeneralComponents/SearchResults/searchFilters/singleSelectFilter/SingleSelectFilter.module.scss"],"names":[],"mappings":"AACI;EACI,gBAAA;EACA,UAAA;EACA,SAAA;AAAR;AAEQ;EACI,oBAAA;AAAZ;AAGQ;EACI,cAAA;EACA,gBAAA;EACA,eAAA;AADZ;AAGY;EACI,cAAA;AADhB;AAIY;EACI,iBAAA;EACA,cAAA;EACA,eAAA;AAFhB","sourcesContent":[".single-select-filter {\r\n    ul {\r\n        list-style: none;\r\n        padding: 0;\r\n        margin: 0;\r\n\r\n        li {\r\n            padding-bottom: 10px;\r\n        }\r\n\r\n        a {\r\n            color: #0C3058;\r\n            transition: 0.3s;\r\n            font-size: 16px;\r\n\r\n            &:hover, &.selected {\r\n                color: #0068F5;\r\n            }\r\n\r\n            span {\r\n                padding-left: 5px;\r\n                color: #0C3058;\r\n                font-size: 16px;\r\n            }\r\n        }\r\n    }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"single-select-filter": `K5uLBV2MralLwfsjdhKn`,
	"selected": `luBhwvTr4AVXuicFVXFp`
};
export default ___CSS_LOADER_EXPORT___;
